'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  index: -1,
  key: null,
  width: 0,
  height: 0,
  bitrate: 0,
  label: null
});
module.exports = exports['default'];